import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box } from 'reflexbox';
import { getText } from 'helpers/i18n';
import { formatPrice } from 'helpers/Price';

import './orderTotal.styles.scss';

export default class OrderTotal extends Component {
    render() {
        const { totalPrice, totalPriceExclVAT, vat,  withFamilyDiscount, leftToPay, includeDeliveryCost } = this.props;
        let showTaxBreakdown = window.Checkout.settings.show_tax_breakdown.onlineshoppinglist;

        if (!totalPrice) {
            return null;
        }

        // order_total_label_family
        // order_total_label_regular
        // order_subtotal_label_family
        // order_subtotal_label_regular
        let totalText = getText(
            'order_' + (includeDeliveryCost ? 'total' : 'subtotal') +
            '_label_' + (withFamilyDiscount ? 'family' : 'regular')
        );

        let totalPriceFormatted = formatPrice(totalPrice);

        if (leftToPay !== false) {
            totalText = getText('order_total_left_to_pay');
            totalPriceFormatted = formatPrice(leftToPay);
            showTaxBreakdown = false;
        }

        return (
            <Box py={1} className={'ordertotal ordertotal--' + (withFamilyDiscount && (leftToPay === false) ? 'family' : 'regular')}>
                { showTaxBreakdown &&
                    <div className="ordertotal__taxbreakdown">
                        <div className="ordertotal__row">
                            <span className="ordertotal__subtotalexclvat-label">{getText('order_total_exclvat_label')}</span>
                            <span className="ordertotal__subtotalexclvat-price">{formatPrice(totalPriceExclVAT)}</span>
                        </div>
                        <div className="ordertotal__row">
                            <span className="ordertotal__totalvat-label">{getText('order_total_vat_label')}</span>
                            <span className="ordertotal__totalvat-price">{formatPrice(vat)}</span>
                        </div>
                    </div>
                }
                <div className="ordertotal__row">
                    <span className="ordertotal__subtotal-label" dangerouslySetInnerHTML={{ __html: totalText }} />
                    <span className="ordertotal__subtotal-price">{totalPriceFormatted}</span>
                </div>
            </Box>
        );
    }
}

OrderTotal.propTypes = {
    totalPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
    totalPriceExclVAT: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
    vat: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
    withFamilyDiscount: PropTypes.bool.isRequired,
    leftToPay: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    includeDeliveryCost: PropTypes.bool,
    processing: PropTypes.bool,
    prices: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.bool,
    ]),
    deliverySubType: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
};
